import { render, staticRenderFns } from "./share-shortlist.vue?vue&type=template&id=04d7387c&scoped=true&"
import script from "./share-shortlist.vue?vue&type=script&lang=ts&"
export * from "./share-shortlist.vue?vue&type=script&lang=ts&"
import style0 from "./share-shortlist.vue?vue&type=style&index=0&id=04d7387c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7387c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDialog,VForm})
